export default __webpack_public_path__ + "static/media/people.dfc07e3a.svg";